import * as React from 'react';
import { Props } from 'react';

import './Spiner.scss';

interface SpinerProps extends Props<Spiner> {
    icon?: string;
    channelId: string;
}

export class Spiner extends React.Component<SpinerProps> {
    render() {
        const {icon, channelId} = this.props;
        return (
            <div className={`auth-spiner-container ${channelId}`}>
                <i className={`fa fa-${icon ? icon : 'spinner'} fa-spin`} />
            </div>
        );
    }
}

export default Spiner;



// WEBPACK FOOTER //
// ./src/components/RegistrationAuthorization/Spiner/Spiner.tsx